// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b9-4";
export var collapsed = "_b9-1";
export var headerBar = "_b9-0";
export var leftHeaderContent = "_b9-3";
export var subjectContainer = "_b9-2";